import { useState, useContext } from 'react'
import { SnackbarContext } from 'contexts/SnackbarContext'
import {
  getMyClaims,
  getClaimById,
  sendMessage,
  Claim,
  SendMessageParams
} from 'api/claims'
import { useTranslation } from 'react-i18next'

const useClaims = () => {
  const { t } = useTranslation()
  const [claims, setClaims] = useState<Claim[]>([])
  const [isLoadingClaims, setIsLoadingClaims] = useState<boolean>(true)
  const { showMessage } = useContext(SnackbarContext)

  const fetchClaims = async () => {
    setIsLoadingClaims(true)
    const result = await getMyClaims()
    if (result.success && result.claims) {
      setClaims(result.claims)
    } else {
      showMessage(result.error || t('snackbar.claims.loadFailed'), 'error')
    }
    setIsLoadingClaims(false)
  }

  const fetchClaimById = async (claimId: string): Promise<Claim | null> => {
    const result = await getClaimById(claimId)
    if (result.success && result.claim) {
      return result.claim
    } else {
      showMessage(result.error || t('snackbar.claims.detailsFailed'), 'error')
      return null
    }
  }

  const sendClaimMessage = async (
    claimId: string,
    params: SendMessageParams
  ): Promise<boolean> => {
    const result = await sendMessage(claimId, params)
    if (result.success) {
      return true
    } else {
      showMessage(result.error || t('snackbar.claims.sendFailed'), 'error')
      return false
    }
  }

  return {
    claims,
    fetchClaims,
    fetchClaimById,
    sendClaimMessage,
    isLoadingClaims
  }
}

export default useClaims
